import styled from 'styled-components'

import ConfirmCancelButtonsOriginal from 'components/Buttons/ConfirmCancelButtons'
import { colors } from 'themes'

import noCard from 'images/noCard.svg';

export const Container = styled.div`
    background: ${colors.billingLocation.background};
    border-radius: 16px;
    color: ${colors.billingLocation.text};
    font-size: 1.42em;
    padding: 24px;
`

export const Header = styled.p`
	font-weight: bold;
`

export const InfoText = styled.p`
	line-height: 30px;
	font-weight: normal;
	margin: 20px 0;
	
	@media (max-width: 500px) {
		font-size: 0.8em;
	}
`

export const LocationText = styled.p`
	min-width: 0;
	margin-left: 10px;
	white-space: nowrap;
	text-overflow: fade;
	overflow: hidden;
`

export const LocationNoCardIcon = styled.img.attrs({
	src: noCard,
})`
	z-index: 20;
	position: absolute;
	right: 15px;
`

export const AddLocationButton = styled.div`
	border-bottom: 1px solid ${colors.billingLocation.selectedBackground};
	padding: 15px;
	:hover {
		opacity: 0.7;
	};
	transition: 300ms ease;
`

export const ConfirmCancelButtons = styled(ConfirmCancelButtonsOriginal)`
	margin-top: 25px;
`
